<template>
  <div :class="`${question.answerColClass || 'col'} field`">
    <cleave
      :placeholder="question.placeholder"
      :data-qa="question.serverPath"
      :name="question.labelInput"
      :disabled="question.disabled && isDisabled"
      :type="question.inputType && question.inputType"
      :class="['form-control', filled, question.fieldClass]"
      :options="question.cleaveOptions"
      v-model="localResponse"
      @focus="isUserEditing = true"
      @blur="handleBlur"
      @input="handleInput"
    />
    <label v-if="question.labelInput"
      >{{ question.labelInput }}
      <tooltip-element
        v-if="question.tooltipImage || question.tooltipText"
        :class="['question-tooltip']"
        :question="question"
      />
    </label>
    <label v-if="question.labelSuffix">{{ question.labelSuffix }}</label>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Cleave from "vue-cleave-component";

import "cleave.js/dist/addons/cleave-phone.fr";

import { getProp } from "../../utils/SurveyUtils";

export default {
  props: ["question", "path", "responsePath"],
  data: function () {
    return {
      localResponse: null,
      isUserEditing: false,
    };
  },
  computed: {
    ...mapGetters(["isDisabled"]),
    storeValue() {
      return getProp(this.question, this.responsePath, "response");
    },
    filled() {
      return this.localResponse && this.localResponse.length > 0 && "filled";
    },
  },
  methods: {
    ...mapActions(["setValue", "checkError"]),
    handleInput(e) {
      // Pour Cleave, la valeur peut venir de e.target.value ou directement de e
      const value = e.target ? e.target.value : (typeof e === 'string' ? e : this.localResponse);
      this.checkError({ path: this.path, responsePath: this.responsePath, value });
    },
    handleBlur(e) {
      // Utilise la valeur locale plutôt que e.target.value qui peut être undefined
      const value = this.localResponse;
      this.setValue({ path: this.path, responsePath: this.responsePath, value });
      this.isUserEditing = false;
    }
  },
  watch: {
    storeValue: {
      handler(newValue) {
        // Synchronise seulement si l'utilisateur n'est pas en train d'éditer
        if (newValue !== this.localResponse && !this.isUserEditing) {
          this.localResponse = newValue;
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    // Initialisation avec la valeur du store
    this.localResponse = this.storeValue;
  },
  components: {
    Cleave,
  },
};
</script>